export default () => {
  let openFlg = false;

  function close() {
    $('.l-header__inner').removeClass('is-open');
    $('body').removeClass('is-menu-open');
    $('.js-header-menu').find('span').text('menu');
    $('body').addClass('is-menu-leady');
    setTimeout(() => {
      $('body').removeClass('is-menu-leady');
      $('.l-header__menu').scrollTop(0); // 閉じきってから先頭に戻す
    }, 500);
    openFlg = false;
  }

  function open() {
    $('body').addClass('is-menu-open');
    $('.l-header__inner').addClass('is-open');
    $('body').addClass('is-menu-leady');
    setTimeout(() => {
      $('body').removeClass('is-menu-leady');
    }, 500);
    openFlg = true;
  }

  $('.js-header-menu').on('click', () => {
    if ($('.l-header__inner').hasClass('is-open')) {
      close();
    } else {
      open();
    }
    return false;
  });

  // $('.js-gnav-button').on('click', function(){
  //   if($(this).parent().hasClass('is-open')){
  //     $(this).parent().removeClass('is-open');
  //   } else {
  //     $(this).parent().addClass('is-open');
  //   }
  //   return false;
  // })

  $(document).on('click', '.l-header__inner.is-open a', function(e) {
    const url = new URL(this.href, location.href);
    // 同じページ内のアンカー（パスが一致 && ハッシュあり）なら閉じる
    if (url.pathname === location.pathname && url.hash) {
      close();
    }
  });
};